import { SxProps, Theme, Typography } from "@mui/material";
import { isNil } from "lodash-es";

import { CurrencyCode } from "@/core/api/generated/v1";

import InlineApiEnumValue from "../../Enum/InlineApiEnumValue";

interface Props {
  currencyCode?: CurrencyCode | null;
  sx?: SxProps<Theme>;
}

/** Displays currency info. */
export default function CurrencyCodeDisplay({ sx, currencyCode }: Props) {
  if (isNil(currencyCode)) {
    return null;
  }
  return (
    <Typography component='span' color='text.secondary' sx={sx}>
      <InlineApiEnumValue type='CurrencyCode' value={currencyCode} />
    </Typography>
  );
}
